<template>
  <div class="login-container">
    <LogoTile @click="home" />
    <span class="title">Try us for free</span>
    <div class="subtitle">
      Already have an account?
      <router-link :to="{ name: 'Login' }" class="white-link" tabindex="0">
        <span>Sign in</span> </router-link
      >.
    </div>
    <div class="login-content">
      <div class="floating-label has-icon">
        <input
          v-model="email"
          placeholder="Please enter your email"
          type="email"
          name="email"
          id="email"
          autofocus
          autocomplete="off"
        />
        <label for="email">Email</label>
        <div class="input-icon">
          <MailIcon class="icon mini" />
        </div>
      </div>
      <button
        @click="next()"
        class="button-default big continue plausible-event-name=Sign+Up"
        tabindex="0"
      >
        <span>Continue</span>
      </button>
    </div>
  </div>
</template>
<script>
import LogoTile from "@/components/LogoTile";
import MailIcon from "@/assets/img/svg/mail.svg";
import { M_CHECK_SIGNUP_STEP } from "@/graphql";

export default {
  name: "SignupWizardStepEmail",
  components: {
    LogoTile,
    MailIcon
  },
  data() {
    return {
      email: null,
      isLoading: false,
      discount: null
    };
  },
  created() {
    this.$store.commit("signup/reset");
    this.$store.commit("logout");
    // const client = this.$apollo.getClient();
    // client.stop();
    const coupon = this.$cookies.get("coupon");
    if (coupon) {
      this.discount = coupon;
      this.$store.commit("signup/setCoupon", coupon);
    }
  },
  computed: {
    invalidEmail() {
      return !(this.email || "").match(
        /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    }
  },
  methods: {
    async checkStep() {
      const result = await this.$apollo.mutate({
        client: "localClient",
        mutation: M_CHECK_SIGNUP_STEP,
        variables: {
          email: this.email,
          coupon: this.discount
        }
      });
      console.log("adadasdsd", result);
      return result;
    },
    setEmail() {
      this.$store.commit("signup/setEmail", this.email);
    },
    async next() {
      if (
        !(this.email || "").match(
          /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
      ) {
        return this.$store.dispatch("snack", {
          type: "error",
          text: "Please enter a valid email address."
        });
      }

      this.isLoading = true;
      const signup = await this.checkStep();
      this.isLoading = false;
      if (signup.data.signup_check_step.signup_finished) {
        if (this.discount === "KLOUTED") {
          window.clickmagick_cmc = {
            uid: "157588",
            hid: "112900509",
            cmc_email: this.email
          };
        }

        const coupon = this.$cookies.get("coupon");
        if (coupon) {
          this.$cookies.remove("coupon");
          this.$cookies.remove("coupon_months");
          this.$cookies.remove("coupon_prepend");
          this.$cookies.remove("discount_name");
        }

        await this.$router.push({
          name: "Login",
          params: { existing_email: this.email }
        });
      } else {
        this.setEmail();
        this.$store.commit(
          "signup/setEmailPending",
          signup.data.signup_check_step.email_pending
        );
        this.$emit("nextStep");
      }
    },
    async home() {
      await this.$router.push({ name: "Homepage" });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: 100%;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .close {
    cursor: pointer;
    position: fixed;
    top: 44px;
    right: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:hover {
      svg {
        path {
          fill: white;
        }
      }
      .close-text {
        color: white;
      }
    }
    svg {
      width: 18px;
      margin: 3px 0;
      path {
        fill: #8786ab;
      }
    }
    .close-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 10px;
      text-transform: uppercase;
      /* Text/type2 */
      color: $text-type-2;
    }
  }
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    margin-top: 30px;
    button.continue {
      margin-top: 22px;
      width: 100%;
    }
    .login {
      margin-top: 117px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .login-text {
        margin-bottom: 10px;
        /* 16/Regular */
        font-size: 16px;
        line-height: 24px;
        /* Text/type0 */
        color: $text-type-0;
      }
    }
  }
  .white-link {
    color: #fff;
    cursor: pointer;
  }
}
</style>
